import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PlModalMessageButton {
  text: string;
  value?: string;
  type?: 'primary' | 'secondary';
  class?: string;
}

export interface PlModalMessageData {
  title: string;
  image?: string;
  message: string;
  buttons: PlModalMessageButton[];
  align?: 'left' | 'center' | 'right';
  alignButtons?: 'center' | 'end';
  hasBackdrop?: true | false;
}

@Component({
  selector: 'pl-modal-message',
  templateUrl: './modal-message.component.html',
  styleUrls: ['./modal-message.component.scss'],
})
export class ModalMessageComponent {
  alignText = 'text-center';

  alignButtons = 'end';

  constructor(@Inject(MAT_DIALOG_DATA) public data: PlModalMessageData) {
    if (data?.align) {
      this.alignText = `text-${data.align}`;
    }
    if (data?.alignButtons) {
      this.alignButtons = data.alignButtons;
    }
  }
}
